:host {
  direction: ltr;
  display: inline-block;
}
.hidden {
  visibility: hidden;
}
.clock {
  color: var(--av-color-tray);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-weight: bold;
  font-size: 1.1em;
}
